const BASE_URL = 'api/admin/import-connections'
const VALIDATE_URL = `${BASE_URL}/validate`

export {
	BASE_URL,
	VALIDATE_URL
}